import React, {Component} from "react";
import SecureLayout from './../../../templates/secure';
import _ from 'lodash';

class ProjectsSearch extends Component {
	render() {
		const {projects, modalities, versions, entities} = this.props;

		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>

			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={projects.filters.q} onChange={this._searchChange}/>
			</div>

			<div className="control">
				<div className={`select is-small${modalities.isFetching ? ' is-loading' : ''}`}>
					<select name="modality_id" id="modality_id" value={projects.filters.modality_id} onChange={this._modalityChange} disabled={modalities.isFetching}>
						<option value="">--- Categoría ---</option>
						{_.map(modalities.list, (row, k) => {
							return (
								<option key={k} value={row.id}>{row.name}</option>
							)
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<div className={`select is-small${entities.isFetching ? ' is-loading':''}`} >
					<select name="state_id" id="state_id" value={projects.filters.state_id} onChange={this._entityChange}>
						<option value="">--- Entidad ---</option>
						{_.map(entities.list, (row, k) => {
							return (
								<option key={k} value={row.id}>{row.name}</option>
							)
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<div className={`select is-small${versions.isFetching ? ' is-loading' : ''}`}>
					<select name="version_id" id="version_id" disabled={versions.isFetching} value={projects.filters.version_id} onChange={this._versionChange}>
						<option value=" " defaultValue>--- Año ---</option>
						{_.map(versions.list,(version, k) => {
							return <option value={version.id} key={k}>{version.year}</option>
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<a className="button is-inm-purple is-small" onClick={() => this._submitSearch(this.refs.q)}>Buscar</a>
			</div>
		</div>
	}

    constructor() {
        super();
        this._submitSearch = this._submitSearch.bind(this);
        this._searchChange = this._searchChange.bind(this);
        this._modalityChange = this._modalityChange.bind(this);
        this._entityChange = this._entityChange.bind(this);
        this._versionChange = this._versionChange.bind(this);
        this._clearSearch = this._clearSearch.bind(this);
    }

	componentWillMount() {
		this.props.fetchModalities();
		this.props.fetchEntities();
		this.props.versionsList();
	}
    _submitSearch() {
		const {projects} = this.props;
        this.props.fetchProjects(1,projects.filters)
    }

	_searchChange(event){
		this.props.change('projects.filters.q',event.target.value);
	}

	_modalityChange(event){
		this.props.change('projects.filters.modality_id',event.target.value);
	}

	_entityChange(event){
		this.props.change('projects.filters.state_id',event.target.value);
	}

	_versionChange(event){
		this.props.change('projects.filters.version_id',event.target.value);
	}


	_clearSearch(){
		this.props.reset('projects.filters');
		this.props.fetchProjects(1);
	}
}

export default SecureLayout(ProjectsSearch);



// WEBPACK FOOTER //
// ./src/elements/projects/widgets/project_search.jsx